module.exports = __webpack_public_path__ + "img/xueShan4.9e966731.png";